import React, {useEffect} from "react";
import {useAsync} from "react-async-hook";
import {combinePromises} from "src/commun/utils/promiseUtils";
import {fetchCGU, fetchConfiguration} from "./api/PublicApi";
import AppMonEspacePrive from "./AppMonEspacePrive";
import {StateProvider} from "./state/StateProvider";
import {State, stateReducer} from "./state/stateReducer";
import AppSpinner from "src/commun/composants/AppSpinner/AppSpinner";
import {fetchUser} from "src/app/api/AccountApi";
import useGetUuidEmployeurOuTiersFromUrl from "src/commun/hooks/useGetUuidEmployeurOuTiersFromUrl";
import {AppLangue} from "src/commun/AppTypes";
import { initAnalytics } from "src/app/analytics/analyticsUtils";

const fetchInitialAppState = (): Promise<State> => {

  const lang = getLangueNavigateur();
  return combinePromises({
    user: fetchUser(),
    cguLink: fetchCGU(),
    configuration: fetchConfiguration(),
  }).then(res => {

    initAnalytics(res.configuration.urlAnalytics);

    return {
      ...res,
      services: undefined,
      bai: undefined,
      cybersafe:undefined,
      menuGauche: undefined,
      favoris: undefined,
      employeurs: undefined,
      employeurContextuel: undefined,
      langue: lang as AppLangue,
      menu: undefined,
      traductions: undefined,
    };

  });
};

const getLangueNavigateur = () => {
  let lang = navigator.language.substring(0, 2);
  if (!lang || !["en", "fr", "de"].includes(lang)) {
    lang = "fr";
  }

  return lang;
};

export const redirectUrlMep: string = "redirectUrlMep";

const AppLauncher = () => {
  const uuidEmployeurOuTiersInUrl = useGetUuidEmployeurOuTiersFromUrl();

  const initialState = useAsync(fetchInitialAppState, []);

  useEffect(() => {
    const urlRedirect = sessionStorage.getItem(redirectUrlMep);
    if (urlRedirect != null) {
      sessionStorage.removeItem(redirectUrlMep);
      window.location.assign(urlRedirect);
    }
  }, []);

  if (initialState.status === "loading") {
    return <AppSpinner animation="grow"/>;
  }

  return (
    <StateProvider initialState={{ ...initialState.result! }} stateReducer={stateReducer} uuidEmployeurOuTiersInUrl={uuidEmployeurOuTiersInUrl}>
      <AppMonEspacePrive/>
    </StateProvider>
  );
};

export default AppLauncher;

